/**
 * License workflow helpers
 * Pure functions with no external dependencies.
 */

export const LICENSE_STATUS_TYPE_ACTIVE = 'active';
export const LICENSE_STATUS_TYPE_INACTIVE = 'inactive';
export const LICENSE_STATUS_TYPE_PENDING = 'pending';

export function buildLicenseWorkflow({
  workflow,
  builtinStatuses,
  includeBuiltinStatusesDefault = true,
  defaultStatusCode = 'submitted'
}) {
  const data = {
    statuses: [],
    defaultStatus: defaultStatusCode,
    ...(workflow || {})
  };

  if (data.includesBuiltinStatuses === undefined || data.includesBuiltinStatuses === null) {
    data.includesBuiltinStatuses = includeBuiltinStatusesDefault;
  }

  if (data.includesBuiltinStatuses === true) {
    const builtinIds = new Set((builtinStatuses || []).map(s => s.id));
    data.statuses = [
      ...(builtinStatuses || []),
      ...(data.statuses || []).filter(s => !builtinIds.has(s.id))
    ];
  }

  return data;
}

export function addWorkflowStatus(statuses, { id, code = '', label = '', description = '', type = LICENSE_STATUS_TYPE_PENDING }) {
  const next = Array.isArray(statuses) ? [...statuses] : [];
  next.push({
    id: id || `${Math.round(Math.random() * 1000000000)}`,
    code,
    label,
    description,
    type
  });
  return next;
}

export function removeWorkflowStatus(statuses, id) {
  const next = Array.isArray(statuses) ? statuses : [];
  return next.filter(status => status.id !== id);
}

export function resolveWorkflowDefaultStatusId({ defaultStatus, statuses }) {
  const idOrCode = defaultStatus;
  const status = (statuses || []).find(s => s.id === idOrCode || s.code === idOrCode);
  return status?.id;
}

export function resolveWorkflowDefaultStatusCode({ defaultStatus, statuses }) {
  const idOrCode = defaultStatus;
  const status = (statuses || []).find(s => s.id === idOrCode);
  return status?.code || idOrCode;
}
